import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const FOBIncomingConsignment = () => {
  return (
    <SectionIncomingConsignment 
      sectionName="FOB"
      sectionDisplayName="FOB"
      backRoute="/sections/fob"
    />
  );
};

export default FOBIncomingConsignment;
